export const currencyList = [
  'SR Saudi riyal',
  '£ Saint Helenian Pound',
  '₹ Indian Rupee',
  '£ Pound Sterling',
  '$ Dollar',
  '￥ Japanese yen',
  '€ Euro',
];
